<template>
  <div>
    <add-user-dialog
      :dialogTitle="dialogTitle"
      :centerDialogVisible="visible"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'600px'"
      :appendToBody="false"
    >
      <el-form ref="form" :model="query" :rules="rule" label-width="120px">
        <el-form-item label="提示:">
          <span v-if="isUnifyIdentity"
            >此功能仅用于添加已关联统一身份的用户。</span
          >
          <span v-if="!isUnifyIdentity"
            >此功能仅用于在本企业下添加平台已有用户，不用于创建新用户！</span
          >
        </el-form-item>
        <el-form-item
          :label="isUnifyIdentity ? '统一身份账号:' : '登录账号:'"
          prop="memberName"
        >
          <el-input
            v-if="!isUnifyIdentity"
            v-model="query.memberName"
            @input="handleInput"
            class="input-style"
          ></el-input>
          <el-input
            v-if="isUnifyIdentity"
            v-model="query.uid"
            @input="handleInput"
            class="input-style"
          ></el-input>
          <el-button style="height: 30px" type="primary" @click="handleSearch"
            >查询</el-button
          >
          <div
            style="width: 300px;z-index: 9999;position: absolute; background-color: #ffffff; border: 1px solid #8c939d;"
            v-if="items.length != 0"
          >
            <ul>
              <li
                style="cursor: pointer"
                @click="handleSelectItem(item)"
                v-for="item of items"
                :key="isUnifyIdentity ? item.uid : item.memberName"
              >
                {{ isUnifyIdentity ? item.uid : item.memberName }}
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="真实姓名:" prop="realName">
          <el-input v-model="query.realName" class="input-style"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" prop="mobile">
          <el-input
            v-model="query.mobile"
            disabled
            class="input-style"
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱:" prop="email">
          <el-input
            v-model="query.email"
            disabled
            class="input-style"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名称:" prop="companyName">
          <el-select v-model="query.companyName" style="width: 300px">
            <el-option
              v-for="item in companyNameList"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!isUnifyIdentity"
          label="业务方向:"
          prop="businessType"
        >
          <el-checkbox-group v-model="query.businessType">
            <el-checkbox
              v-for="(item, index) in businessList"
              :label="item.businessType"
              :key="index"
              >{{ formatBusinessType(item.businessType) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          v-if="isUnifyIdentity"
          label="业务方向:"
          prop="businessType"
        >
          <el-checkbox-group
            v-model="query.businessType"
            v-if="businessList.length == 1"
          >
            <el-checkbox
              disabled
              v-for="(item, index) in businessList"
              :label="item.businessType"
              :key="index"
              >{{ formatBusinessType(item.businessType) }}</el-checkbox
            >
          </el-checkbox-group>
          <el-checkbox-group
            v-model="query.businessType"
            v-if="businessList.length !== 1"
          >
            <el-checkbox
              v-for="(item, index) in businessList"
              :label="item.businessType"
              :key="index"
              >{{ formatBusinessType(item.businessType) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="所属部门:" prop="department">
          <el-input
            ref="getFocus"
            v-model="query.department"
            @focus="selectDepartment"
            class="input-style"
          ></el-input>
        </el-form-item>
      </el-form>
    </add-user-dialog>
    <SelectDepartmentDialog
      :visible="selectDepartmentDialogShow"
      v-if="selectDepartmentDialogShow"
      @close="closeSelectDepartmentDialog"
      @getNode="getCurrentNode"
    ></SelectDepartmentDialog>
  </div>
</template>

<script>
import AddUserDialog from "../../../../components/common/epecDialog";
import SelectDepartmentDialog from "../../components/authority/selectDepartmentDialog";
import Api from "../../api/authority/index";
export default {
  name: "addExistUserDialog",
  components: {
    AddUserDialog,
    SelectDepartmentDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      query: {
        memberName: "",
        realName: "",
        mobile: "",
        email: "",
        department: "",
        orgId: "",
        companyName: "",
        businessType: [],
        uid: "",
      },
      selectDepartmentDialogShow: false,
      businessList: [],
      rule: {
        businessType: [
          { required: true, message: "请选择业务方向", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "blur" },
        ],
      },
      companyNameList: [],
      items: [],
      timer: null,
      isUnifyIdentity: this.$store.state.USERINFO.unifyIdentity, ///1是统一身份，0不是统一身份
    };
  },
  computed: {
    // search() {
    //     console.log(3333)
    //     if (!this.query.memberName) {
    //         return this.companyNameList;
    //     }
    //     return this.companyNameList.filter(v => {
    //         return v.memberName.includes(this.query.memberName);
    //     });
    // }
  },
  created() {
    this.getBusinessType();
  },
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit("close");
    },
    submitPopupData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = this.isUnifyIdentity
            ? {
                memberId: this.query.memberId,
                businessType:
                  this.query.businessType.length == 2
                    ? 3
                    : this.query.businessType[0],
                orgId: this.query.orgId,
                uid: this.query.uid,
                cn: this.query.realName,
              }
            : {
                memberId: this.query.memberId,
                businessType:
                  this.query.businessType.length == 2
                    ? 3
                    : this.query.businessType[0],
                orgId: this.query.orgId,
                memberName: this.query.memberName,
                cn: this.query.realName,
              };
          Api.relationCompany(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                type: "success",
                message: "新增已有员工成功",
              });
              this.$emit("close");
            }
          });
        }
      });
    },
    selectDepartment() {
      this.selectDepartmentDialogShow = true;
    },
    closeSelectDepartmentDialog() {
      this.selectDepartmentDialogShow = false;
      // this.$nextTick(function() {
      //     if (this.timer) {
      //         clearTimeout(this.timer);
      //     }
      //     this.timer = setTimeout(() => {// 100毫秒延迟解决第二次打开支付框，输入框不自动获取焦点的bug
      //         this.$refs.getFocus.focus();// 等价  document.getElementById("inputValId").focus();
      //
      //     }, 100);
      // });
    },
    getCurrentNode(val) {
      this.query.department = val.shortFullName;
      this.query.orgId = val.orgId;
    },
    handleSearch() {
      let params = this.isUnifyIdentity
        ? {
            uid: this.query.uid,
          }
        : { memberName: this.query.memberName };
      if (!this.isUnifyIdentity && this.query.memberName == "") {
        this.$message({
          type: "error",
          message: "请输入登录账号",
        });
        return;
      }
      if (this.isUnifyIdentity && this.query.uid == "") {
        this.$message({
          type: "error",
          message: "请输入统一登录账号",
        });
        return;
      }
      this.companyNameList = [];

      if (this.isUnifyIdentity == 1) {
        Api.queryUnityIdentity(params).then((res) => {
          if (res.code == "200") {
            if (res.data.length) {
              this.query.realName = res.data[0].cn;
              this.query.companyName = res.data[0].ou;
              this.companyNameList = res.data[0].companyList;
              this.query.orgId = res.data[0].orgId;
              this.query.mobile = res.data[0].telephonenumber;
              this.query.email = res.data[0].mail;
              this.$set(this.query, "memberId", res.data[0].memberId);
              // this.query.businessType = res.data[0].businessType == 3 ? [1,2] : res.data[0].businessType
            } else {
              this.query.memberName = "";
              this.$message({
                type: "error",
                message: "统一登录账号不存在",
              });
            }
          }
        });
      } else {
        Api.queryUserInfo(params).then((res) => {
          if (res.code == "200") {
            if (res.data.length) {
              this.query.realName = res.data[0].realName;
              this.query.companyName = res.data[0].companyList
                ? res.data[0].companyList[0]
                : "";
              this.companyNameList = res.data[0].companyList;
              this.query.orgId = res.data[0].orgId;
              this.query.mobile = res.data[0].mobile;
              this.query.email = res.data[0].email;
              this.$set(this.query, "memberId", res.data[0].memberId);
              // this.query.businessType = res.data[0].businessType == 3 ? [1,2] : res.data[0].businessType
            } else {
              this.query.memberName = "";
              this.$message({
                type: "error",
                message: "登录账号不存在",
              });
            }
          }
        });
      }
    },
    async handleInput() {
      let params = this.isUnifyIdentity
        ? {
            uid: this.query.uid,
          }
        : { memberName: this.query.memberName };
      this.items.length = 0;
      let res = this.isUnifyIdentity
        ? await Api.queryUnityIdentity(params)
        : await Api.queryUserInfo(params);
      if (res.code == "200") {
        if (res.data.length) {
          this.items = res.data;
        }
      } else {
        this.items.length = 0;
      }
    },
    handleSelectItem(item) {
      if (this.isUnifyIdentity) {
        this.query.uid = item.uid;
      } else {
        this.query.memberName = item.memberName;
      }

      this.items = [];
    },
    getBusinessType() {
      let params = {};
      Api.getBusinessType(params).then((res) => {
        if (res.code == "200") {
          this.businessList = res.data;
          if (this.isUnifyIdentity) {
            if (this.businessList.length == 1) {
              this.query.businessType.push(res.data[0].businessType);
            }
          }
        }
      });
    },
    formatBusinessType(val) {
      let res = "";
      switch (val) {
        case 2:
          res = "供应商";
          break;
        case 1:
          res = "采购商";
          break;
      }
      return res;
    },
  },
};
</script>

<style scoped>
.input-style {
  width: 300px;
}
</style>
